/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderCredentialV2StateResponse
 */
export interface ProviderCredentialV2StateResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2StateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2StateResponse
     */
    errorMessage?: string | null;
}

export function ProviderCredentialV2StateResponseFromJSON(json: any): ProviderCredentialV2StateResponse {
    return ProviderCredentialV2StateResponseFromJSONTyped(json, false);
}

export function ProviderCredentialV2StateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2StateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function ProviderCredentialV2StateResponseToJSON(value?: ProviderCredentialV2StateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


